<template>
  <b-col sm="12" :lg="size" :offset="offset">
    <!-- Date Modal -->
    <b-modal
      v-if="withDate"
      title="Choose period"
      class="modal-primary"
      v-model="modalDate"
      @ok="fetchData(), (modalDate = false)"
    >
      <b-form>
        <b-form-group label="From" label-for="date" :label-cols="3">
          <datepicker use-utc
            format="yyyy-MM-dd"
            :bootstrap-styling="true"
            v-model="dateFrom"
            name="dateFrom"
          ></datepicker>
        </b-form-group>
        <b-form-group label="To" label-for="dateTo" :label-cols="3">
          <datepicker use-utc
            format="yyyy-MM-dd"
            :bootstrap-styling="true"
            v-model="dateTo"
            name="dateTo"
          ></datepicker>
        </b-form-group>
      </b-form>
    </b-modal>
    <!-- Date Modal END -->

    <b-card class="backClass" style="min-height:587px">
      <!-- Header -->
      <div slot="header">
        <h5 style="display: inline;" class="card-title mb-0">
          {{ title }}
          <small style="font-weight:600; color:#20a8d8" v-if="withDate">
            {{ from ? from : dateFrom }} <b>|</b> {{ to ? to : dateTo }}
          </small>
        </h5>
        <div class="card-header-actions">
          <b-button
              v-if="chartType !== 'company'"
              variant="transparent p-1"
              @click="downloadExcel()"> 
              <i class="fa fa-file-excel-o" title="Download Excel" aria-hidden="true" style="color: rgb(32, 168, 216);"></i>
          </b-button>
          <b-button variant="transparent p-1" attr="pdf" @click="downloadPDF()">
            <i
              class="fa fa-file-pdf-o"
              style="color: rgb(32, 168, 216);"
              aria-hidden="true"
            ></i>
          </b-button>
          <b-button
            @click="modalDateEvent"
            v-if="withDate"
            variant="transparent p-1"
          >
            <i class="icon-calendar" style="color: #20a8d8;"></i>
          </b-button>
          <b-button @click="toggleFullScreen" variant="transparent p-1">
            <i style="color: #20a8d8;" class="icon-frame"></i>
          </b-button>
        </div>
      </div>
      <!-- Header END -->

      <!-- Financial Switch -->
      <div
        style="width: 100%; display: flex; justify-content: flex-end;"
        v-if="withFinancial"
      >
        <h5>Quantity</h5>
        <c-switch
          class="mx-1"
          color="primary"
          v-model="valueQuantity"
          value="true"
          uncheckedValue="false"
          variant="pill"
        />
        <h5>Financials</h5>
      </div>
      <!-- Financial Switch END -->

      <div class="chart-wrapper">
        <!-- Loading -->
        <div
          style="height: 400px; padding-top: 150px"
          v-if="loadingData"
          class="loading"
        >
          <b-row>
            <b-col lg="12">
              <div class="sk-double-bounce">
                <div class="sk-child sk-double-bounce1"></div>
                <div class="sk-child sk-double-bounce2"></div>
              </div>
            </b-col>
          </b-row>
        </div>
        <!-- Loading END -->

        <!-- Chart -->
        <highcharts
          ref="backRef"
          v-else
          :options="chartOptions"
          class="chart"
          :constructor-type="'chart'"
        />
        <!-- Chart END -->
      </div>

      <!-- Footer -->
      <div slot="footer">
        <b-button
          :disabled="!showAll"
          class="btn-outline"
          variant="outline-primary"
          left
          @click="(showAll = false), fetchData()"
          >Top 10</b-button
        >
        <b-button
          :disabled="showAll"
          class="btn-outline float-right"
          variant="outline-primary"
          right
          @click="(showAll = true), fetchData()"
          >All Data</b-button
        >
        <b-button
          v-if="chartType === 'Shipped'"
          class="btn-outline float-right"
          style="margin-right: 10px;"
          variant="outline-primary"
          right
          @click="showTableAll()"
          >Table View All Data</b-button
        >
      </div>
      <!-- Footer END -->
    </b-card>
  </b-col>
</template>

<script>
import { Switch as cSwitch } from "@coreui/vue";
import Highcharts from "highcharts";
import { Chart } from "highcharts-vue";
import exporting from "highcharts/modules/exporting";
import Datepicker from "vuejs-datepicker";
import { chartFunctionsMixin } from "./addons/chartFunctionsMixin.js";
import { chartOptionsMixin } from "./addons/chartOptionsMixin.js";
exporting(Highcharts);

export default {
  mixins: [chartFunctionsMixin, chartOptionsMixin],
  components: {
    highcharts: Chart,
    Highcharts,
    Datepicker,
    cSwitch
  },
  props: [
    "size",
    "offset",
    "title",
    "withDate",
    "withFinancial",
    "chart",
    "chartType",
    "isCompanyOverall",
    "isCompanyProfile",
    "company",
    "city",
    "cityName",
    "model",
    "modelName"
  ],
  methods: {
    showTableAll() {
      this.$router.push(
        "/base/Tables/?type=" +
          this.chartType +
          "&date_from=" +
          this.dateFrom +
          "&date_to=" +
          this.dateTo
      );
    },
     downloadExcel() {
      this.loading2019 = true;
      let params = {};
      params = {
        date_from: this.dateFrom,
        date_to: this.dateTo,
        model: this.model,
        client: this.city,
        xml: "true",
      };
    
    if (this.chartType === "Received") {
      this.excelDownload = "api/tec/tables/recieved.php";
    }
    if (this.chartType === "Shipped"|| this.chartType==='shipped') {
      this.excelDownload = "api/tec/tables/shipped.php";
    }
    if (this.chartType === "top") {
      this.excelDownload = "api/tec/tables/shipped.php";
    }
    if (this.chartType === "OEM") {
      this.excelDownload = "api/tec/tables/oem_backlog.php";
    }
    if (this.chartType === "OEMShip") {
      this.excelDownload = "api/tec/tables/oem_delivered.php";
    }
    if (this.chartType === "ber"|| this.chartType=== 'BER') {
      this.excelDownload = "api/tec/tables/ber.php";
    }
    if (this.chartType === "eol" || this.chartType=== 'EOL') {
      this.excelDownload = "api/tec/tables/eol.php";
    }
    if (this.chartType === "ntf") {
      this.excelDownload = "api/tec/tables/ntf.php";
    }
    if (this.chartType === "war") {
      this.excelDownload = "api/tec/tables/war.php";
    }
    if (this.chartType === "backlog") {
      this.excelDownload = "api/tec/tables/back.php";
    }
    if (this.chartType === "projects") {
      this.excelDownload = "api/tec/tables/projects.php";
    }
    if (this.chartType === "city") {
      this.excelDownload = "api/tec/tables/shipped.php";
    }
    if (this.chartType === "SubDivisionBacklog") {
      this.excelDownload = "api/tec/tables/subdivision_backlog.php";
    }
    if (this.chartType === "SubDivisionDelivered") {
      this.excelDownload = "api/tec/tables/subdivision_delivered.php";
    }
    if (this.chartType === "company") {
      this.excelDownload = "api/tec/company/table.php";
    }
    
      this.$http
        .get(this.excelDownload, {
          params,
          responseType: "blob"
        })
        .then(
          res => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "TableReport.xlsx");
            document.body.appendChild(link);
            link.click();
            this.loading2019 = false;
          },
          err => {
            this.loading2019 = false;
            console.log(err);
          }
        );
    },
    fetchData() {
      this.loadingData = true;

      let finType = "Fin";
      if (!this.valueQuantity || this.valueQuantity == "false") {
        finType = "Qty";
      }
      let params = {};
      let link = null;
      if (this.isCompanyOverall) {
        link = "api/tec/company/chart_all.php";
      } else if (this.isCompanyProfile) {
        link = "api/tec/company/chart_profile.php";
      } else if (this.city) {
        link = "api/tec/charts/chart_city.php";
      } else if (this.model) {
        link = "api/tec/charts/chart_product.php";
      } else {
        link = "api/tec/charts/chart_data.php";
      }

      params = {
        type: finType,
        date_from: this.dateFrom,
        date_to: this.dateTo,
        chartType: this.chartType,
        company: this.company ? this.company : "",
        client: this.city,
        model: this.model
      };

      this.$http.get(link, { params }).then(
        res => {
          let tmp = res.data.upData;
          tmp.sort((a, b) =>
            parseFloat(a.locationTotal) > parseFloat(b.locationTotal) ? -1 : 1
          );

          let smp = res.data.dnData;
          smp
            ? smp.forEach((value, index) => {
                value.data.sort((a, b) =>
                  parseInt(a[1]) > parseInt(b[1]) ? -1 : 1
                );
              })
            : "";

          if (!this.showAll) {
            this.chartOptions.series[0].data = tmp.slice(0, 10);
          } else {
            this.chartOptions.series[0].data = tmp;
          }
          if (!this.isCompanyProfile) {
            this.chartOptions.drilldown.series = smp;
          }
          if (this.isCompanyOverall) {
            this.chartOptions.drilldown.series = null;
          }
          if (this.isCompanyProfile) {
            this.chartOptions.drilldown.series = null;
          }
          if (this.model) {
            this.chartOptions.drilldown.series = null;
          }

          if (finType == "Fin") {
            this.chartOptions.title.text =
              "Total : $" +
              res.data.totals
                .toFixed(2)
                .replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
          } else {
            this.chartOptions.title.text = "Total units: " + res.data.totals;
          }

          this.loadingData = false;
          setTimeout(() => {
            this.changeHeight();
          });
        },
        err => {
          this.loadingData = false;
          console.log(err);
        }
      );
    }
  },
  mounted() {
    this.fetchData();
  }
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
.highcharts-exporting-group {
  display: none !important;
}
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
.vdp-datepicker__calendar {
  position: absolute !important;
  z-index: 100;
  background: #3a4149 !important;
  width: 300px;
  border: 1px solid #ccc;
}
.form-control:disabled,
.form-control[readonly] {
  background-color: #515b65 !important;
  opacity: 1 !important;
}
/* Uniform icon button sizing and spacing */
.card-header-actions {
  display: flex;
  align-items: center;
  gap: 4px;
}
.card-header-actions .btn {
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  font-size: 14px;
}
.card-header-actions .fa-file-excel-o {
  transform: none !important;
  opacity: 0;
  animation: fadeInIcon 0.2s ease-in 0.5s forwards;
}
@keyframes fadeInIcon {
  to { opacity: 1; }
}
</style>
